import { EXPERIENCE_TYPES, BOOKING_TYPES } from "../types";
import { generateCSV_bookings, refactorBookingObj } from "../../utils/misc";

const INITIAL_STATE = {
  experiences: [],
  totalCount: 0,
  approvedCount: 0,
  pendingCount: 0,
  currentPage: 1,
  loading: false,
  experience: null,
  bookedExperiences: [],
  experienceBookingDetails: null,
  experience_csv: [],
};

const experienceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EXPERIENCE_TYPES.SET_LOADING:
      return { ...state, loading: action.payload };

    case EXPERIENCE_TYPES.SET_EXPERIENCE:
      return {
        ...state,
        experiences: action.payload.results,
        totalCount: action.payload.count,
        approvedCount: action.payload.approved_count,
        pendingCount: action.payload.unapproved_count,
        currentPage: action.payload.page,
      };

    case EXPERIENCE_TYPES.GET_EXPERIENCE:
      return { ...state, experience: action.payload };

    case EXPERIENCE_TYPES.EDIT_EXPERIENCE:
      return { ...state, experience: action.payload };

    case BOOKING_TYPES.SET_BOOKING:
      return {
        ...state,
        bookedExperiences: refactorBookingObj(action.booking),
        experience_csv: generateCSV_bookings(action.booking, "Experience"),
      };

    case BOOKING_TYPES.BOOKING:
      return { ...state, experienceBookingDetails: action.payload };

    default:
      return state;
  }
};

export default experienceReducer;
